import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type RoleDeletionFailedAction = {
	type: 'ROLE_DELETION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): RoleDeletionFailedAction => ({
	type: 'ROLE_DELETION_FAILED',
	payload,
});
